<app-template [useCard]="true" [subTitle]="'Confirmar presença de Representante Oficial'" [customSubtitleFontSize]="'18px'">
  <main class="d-flex justify-content-center">
    <ng-container [ngSwitch]="step">
      <app-authc-step-one *ngSwitchCase="1" [meeting]="meeting()"></app-authc-step-one>
      <app-authc-step-two *ngSwitchCase="2"
                          [user]="user()"
                          [meeting]="meeting()"
                          [prerregistration]="preRegistration()"
                          (updatePreRegistration)="updatePreRegistration($event)"
                          (onRegister)="onRegister($event)"></app-authc-step-two>
      <app-authc-step-three *ngSwitchCase="3" [preRegistration]="preRegistrationAuthority" [userInfo]="user"></app-authc-step-three>
    </ng-container>
  </main>
</app-template>
